import type { JSX } from 'react';

import { ClientRender } from '@change-corgi/core/react/ssr/render';

import { PageAdminTools } from '../components/PageAdminTools';
import { PageBody } from '../components/PageBody';
import { PageHeading } from '../components/PageHeading';
import { PageMeta } from '../components/PageMeta';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<>
			<PageMeta />
			<ClientRender>
				<PageAdminTools />
			</ClientRender>
			<div className="container pb-10">
				<PageHeading />
				<PageBody />
			</div>
		</>
	);
}
